import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withVDSManager } from '@vds-core/utilities';
import ListGroupItem from './ListGroupItem';
import ListGroupItemTitle from './ListGroupItemTitle';
import ListGroupItemSubtitle from './ListGroupItemSubtitle';
import ListGroupItemImage from './ListGroupItemImage';
var propTypes = {
  /**
   * If provided, will render the ListGroup when surface is light or dark.
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * If true, will render top line for first item in the list
   */
  topLine: PropTypes.bool,

  /**
   * If true, will render bottom line for last item in the list
   */
  bottomLine: PropTypes.bool,

  /**
   * @typeName ListGroupData
   * Data array to render list items. If provided, will render the content in the array
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    textHierarchy: PropTypes.oneOf(['titleProminent', 'subtitleProminent']),
    title: PropTypes.shape({
      text: PropTypes.string,
      bold: PropTypes.bool,
      tooltip: PropTypes.shape({
        renderAnchorElement: PropTypes.func,
        id: PropTypes.string,
        disabled: PropTypes.bool,
        containerId: PropTypes.string,
        ariaLabel: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node])
      })
    }),
    subtitle: PropTypes.shape({
      text: PropTypes.string,
      tooltip: PropTypes.shape({
        renderAnchorElement: PropTypes.func,
        id: PropTypes.string,
        disabled: PropTypes.bool,
        containerId: PropTypes.string,
        ariaLabel: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node])
      })
    }),
    subtitleRight: PropTypes.string,
    descriptiveIcon: PropTypes.shape({
      name: PropTypes.string,
      size: PropTypes.oneOfType([PropTypes.oneOf(['XSmall', 'small', 'medium', 'large', 'XLarge']), PropTypes.string]),
      color: PropTypes.string
    }),
    ariaLabel: PropTypes.string,
    actionElement: PropTypes.oneOf(['none', 'icon', 'checkbox', 'textLink', 'toggle']),
    textLink: PropTypes.shape({
      text: PropTypes.string
    }),
    image: PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      size: PropTypes.oneOf(['72', '116'])
    }),
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    'data-analyticstrack': PropTypes.string,
    'data-track': PropTypes.string,
    'data-track-ignore': PropTypes.string,
    'data-clickstream': PropTypes.string
  })),

  /**
   * Determines whether mobile, or desktop fontstacks are used.
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * String, React Component, or HTML to render content of ListItem
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * Allows a unique id to be passed to the component and applied to the outermost wrapper of list group.
   */
  id: PropTypes.string
};
var defaultProps = {
  surface: 'light',
  topLine: false,
  bottomLine: true // DEFAULT

};
var StyledUnorderedList = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledUnorderedList",
  componentId: "VDS__sc-xbct8g-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  width: 100%;\n"])));

var ListGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ListGroup, _React$PureComponent);

  var _super = _createSuper(ListGroup);

  function ListGroup(props) {
    var _this;

    _classCallCheck(this, ListGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_renderChildren", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          viewport = _this$props.viewport,
          surface = _this$props.surface,
          topLine = _this$props.topLine,
          bottomLine = _this$props.bottomLine;
      /** Use Children.toArray to prevent counting conditional rendering of child */

      var CHILDREN_COUNT = React.Children.toArray(children).length;
      return React.Children.map(children, function (child, index) {
        var childElement = child && child.type === React.Fragment ? child.props.children : child;
        childElement = childElement instanceof Array ? childElement[0] : childElement;
        var childType = childElement.type.componentType ? childElement.type.componentType : '';

        if (childType === 'ListGroupItem') {
          return /*#__PURE__*/React.cloneElement(childElement, _objectSpread(_objectSpread({}, childElement.props), {}, {
            viewport: viewport,
            surface: surface,
            topLine: topLine && index === 0,
            bottomLine: !bottomLine ? index !== CHILDREN_COUNT - 1 : bottomLine
          }));
        } else {
          return child;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderItemData", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          topLine = _this$props2.topLine,
          bottomLine = _this$props2.bottomLine,
          viewport = _this$props2.viewport,
          surface = _this$props2.surface;
      return data.length && data.map(function (child, index) {
        if (!child || !Object.keys(child).length) return null;
        var analyticsTrack = child['data-analyticstrack'],
            track = child['data-track'],
            ignoreTrack = child['data-track-ignore'],
            clickStream = child['data-clickstream'];
        return /*#__PURE__*/React.createElement(ListGroupItem, {
          key: "ListGroupItem-".concat(index + 1),
          surface: surface,
          topLine: topLine && index === 0,
          bottomLine: !bottomLine ? index !== data.length - 1 : bottomLine,
          viewport: viewport,
          custom: !!child.children,
          actionElement: child.actionElement,
          subtitleRight: child.subtitleRight,
          descriptiveIcon: child.descriptiveIcon,
          textLink: child.textLink,
          disabled: child.disabled,
          ariaLabel: child.ariaLabel,
          ariaRole: child.ariaRole,
          onClick: child.onClick,
          id: child.id,
          textHierarchy: child.textHierarchy,
          "data-analyticstrack": analyticsTrack,
          "data-track": track,
          "data-track-ignore": ignoreTrack,
          "data-clickstream": clickStream
        }, !child.children && child.image && child.image.src && /*#__PURE__*/React.createElement(ListGroupItemImage, {
          src: child.image.src,
          alt: child.image.alt,
          size: child.image.size
        }), !child.children && child.title && child.title.text && /*#__PURE__*/React.createElement(ListGroupItemTitle, {
          bold: child.title && child.title.bold,
          tooltip: child.title.tooltip && (child.title.tooltip.title || child.title.tooltip.children) ? child.title.tooltip : null
        }, child.title.text), !child.children && child.subtitle && child.subtitle.text && /*#__PURE__*/React.createElement(ListGroupItemSubtitle, {
          tooltip: child.subtitle.tooltip && (child.subtitle.tooltip.title || child.subtitle.tooltip.children) ? child.subtitle.tooltip : null
        }, child.subtitle.text), !!child.children && child.children);
      });
    });

    return _this;
  }

  _createClass(ListGroup, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          ariaLabel = _this$props3.ariaLabel,
          id = _this$props3.id;
      return /*#__PURE__*/React.createElement(StyledUnorderedList, {
        "aria-label": ariaLabel,
        id: id
      }, !data && this._renderChildren(), data && this._renderItemData());
    }
  }]);

  return ListGroup;
}(React.PureComponent);

ListGroup.propTypes = propTypes;
ListGroup.defaultProps = defaultProps;
export default withVDSManager(ListGroup);